import React from "react";
import { StockInventory } from "../../services/identityStockApi";

/** Counts come from the scoped backend inventory, never the current page of tags. */
export default function TagStockSummary({ inventory }: { inventory: StockInventory }) {
  const count = (...keys: string[]) => {
    const values = keys.map(key => inventory.counts[key]);
    return values.every(value => Number.isSafeInteger(value) && value >= 0)
      ? values.reduce((total, value) => total + value, 0).toLocaleString() : "—";
  };
  const scope = inventory.holderType === "HKP_STOCK" ? "HKP central stock"
    : inventory.holderType === "COLLECTOR" ? "Customer stock" : "Studio stock";
  return <section aria-label="Tag stock summary">
    <p><strong>{scope}</strong> · All pages · {inventory.total.toLocaleString()} tag {inventory.total === 1 ? "record" : "records"} including history</p>
    <div className="identity-stock-summary">
      <div className="identity-stock-stat"><h3>Unused</h3><strong>{count("AVAILABLE", "ALLOCATED")}</strong><p>Active tags ready to attach</p></div>
      <div className="identity-stock-stat"><h3>Attached</h3><strong>{count("BOUND")}</strong><p>Active tags linked to an item or loom</p></div>
      <div className="identity-stock-stat"><h3>Damaged / Replaced</h3><strong>{count("DAMAGED", "REPLACED")}</strong><p>Historical carriers; excluded from active stock</p></div>
    </div>
    <p>Lost: {count("LOST")} · Retired: {count("RETIRED")}. Counts refer to physical tags, not unique products. — means the count is unavailable.</p>
  </section>;
}
